module.exports = __webpack_public_path__ + "img/lieve-tandarts-liggend.257402a4.png";